__turbopack_context__.v({
  "bottom-center": "FQp8nW_bottom-center",
  "container": "FQp8nW_container",
  "image": "FQp8nW_image",
  "label": "FQp8nW_label",
  "labelOverlay": "FQp8nW_labelOverlay",
  "picture": "FQp8nW_picture",
  "top-left": "FQp8nW_top-left",
});
